import axios from 'axios';
import { API_URL } from '@/config/runtime';
import { clearStoredUser, getAccessToken } from './session';

const apiClient = axios.create({
  baseURL: API_URL,
});

apiClient.interceptors.request.use((request) => {
  const token = getAccessToken();

  if (token) {
    request.headers = request.headers || {};
    request.headers['x-access-token'] = token;
  }

  return request;
});

apiClient.interceptors.response.use(
  response => response,
  (error) => {
    const isExpired = error.response?.status === 401
      || error.response?.data?.Message === 'Token expired';

    if (isExpired) {
      clearStoredUser();

      if (typeof window !== 'undefined' && window.location.pathname !== '/login') {
        window.location.assign('/login');
      }
    }

    return Promise.reject(error);
  },
);

export default apiClient;

